const convertToCSV = objArray => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  let str = '';

  array.map(row => {
    let line = '';

    Object.keys(row).map(item => {
      if (line !== '') {
        line += ',';
      }

      if (row[item] === null) {
        line += '';
      } else {
        line += `"${typeof row[item] === 'string' ? row[item].replace(/"/g, '""') : row[item]}"`;
      }

      return true;
    });

    str += `${line}\r\n`;
    return true;
  });

  return `\ufeff${str}`;
};

const csvExporter = (headers, items, fileTitle) => {
  if (headers) {
    items.unshift(headers);
  }

  const csv = convertToCSV(JSON.stringify(items));
  const blob = new Blob([csv], {
    type: 'text/csv;charset=utf-8;',
  });

  const link = document.createElement('a');

  if (typeof link.download !== 'undefined') {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', fileTitle ? `${fileTitle}.csv` : 'export.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export default csvExporter;
